import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import Chip from '@material-ui/core/Chip';
import CardHeader from '@material-ui/core/CardHeader';
import Divider from '@material-ui/core/Divider';
import Hidden from '@material-ui/core/Hidden';
import IconButton from '@material-ui/core/IconButton';
import LinearProgress from '@material-ui/core/LinearProgress';
import { withStyles } from '@material-ui/core/styles';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';
import NavigateNext from '@material-ui/icons/NavigateNext';
import BatteryChargingFullIcon from '@material-ui/icons/BatteryChargingFull';
import FlashOnIcon from '@material-ui/icons/FlashOn';
import TuneIcon from '@material-ui/icons/Tune';
import LinkIcon from '@material-ui/icons/Link';
import CheckCircleOutline from '@material-ui/icons/CheckCircleOutline';
import Event from '@material-ui/icons/Event';
import classNames from 'classnames';
import _ from 'lodash';
import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import theme from '../../theme';
import WarrantyCell from './WarrantyCell';
import ProductEnrichPanel from './ProductEnrichPanel';
import { Role_Admin } from '../../constants';
import {
	buildProductDateTooltip,
	formatProductDisplayDate,
	getExpiryUrgency,
} from '../../libs/formatProductDate';
import { formatProductPowerLine } from '../../libs/formatProductPower';

const STICKY_MFR_WIDTH = 168

const styles = {
    space: {
        padding: 0,
    },
	modelCardHeader: {
		padding: theme.spacing(0.5, 0),
		alignItems: 'flex-start',
		'& .MuiCardHeader-content': {
			overflow: 'hidden',
		},
		'& .MuiCardHeader-subheader': {
			marginTop: theme.spacing(0.5),
		},
	},
	modelTitleLink: {
		color: 'inherit',
		textDecoration: 'none',
		fontFamily: 'NHaasGroteskDSPro-65Md',
		'&:hover': {
			textDecoration: 'underline',
			color: theme.palette.primary.main,
		},
	},
	modelTitleRow: {
		display: 'flex',
		alignItems: 'flex-start',
		flexWrap: 'wrap',
		gap: 4,
	},
	failedBadgeRow: {
		display: 'flex',
		alignItems: 'center',
		gap: theme.spacing(0.75),
		flexWrap: 'wrap',
	},
	failedBadgeChip: {
		height: 22,
		fontSize: 11,
		fontWeight: 600,
		color: theme.palette.error.main,
		borderColor: theme.palette.error.light,
		backgroundColor: theme.palette.common.white,
	},
    headerTitle: {
        fontFamily: 'NHaasGroteskDSPro-65Md', padding: 0,
    },
    avatar: {
        borderRadius: 0,
        width:42,
        height:"auto",
        color: 'tranparent'
    },
    avatarBattery: {
        borderRadius: 4,
        width: 42,
        height: 42,
        backgroundColor: '#e8f5e9',
        color: '#2e7d32',
    },
    avatarInverter: {
        borderRadius: 4,
        width: 42,
        height: 42,
        backgroundColor: '#e3f2fd',
        color: '#1565c0',
    },
    row: {
        [theme.breakpoints.down('sm')]: {
            height:"auto",
          //  boxShadow:"0px 1px 3px 0px rgba(0,0,0,0.2),0px 1px 1px 0px rgba(0,0,0,0.14),0px 2px 1px -1px rgba(0,0,0,0.12)",
        },
        '&:nth-of-type(even)': {
            backgroundColor: theme.palette.grey[50],

        },
    
    },
    progress: {
        position: "relative",
    },
    linearColorPrimary: {
        height: 18,
        borderRadius: 4,
        background: theme.palette.background.lightbg,
    },
    linearBarColorPrimary: {
        right: 0,
        transformOrigin: "right",
        background: theme.palette.common.green,
        left: "auto",
        borderRadius: 4,
    },
    linearFailedPrimary: {
        height: 21,
        background: theme.palette.background.lightbg,
    },
    linearFailedBarColorPrimary: {
        background: theme.palette.common.red,
      
    },
    span: {
        position: "absolute",
        top: 0,       
        color: theme.palette.grey[900],
        fontFamily: 'NHaasGroteskDSPro-65Md',
        right: theme.spacing(1),
        lineHeight: "18px",
        fontSize: '0.75rem',
    },
    spanFailed: {
        position: "absolute",
        top: 0,
        left: theme.spacing(1),
        color: theme.palette.common.white,
        fontFamily: 'NHaasGroteskDSPro-65Md',
        lineHeight: "22px",
        [theme.breakpoints.down('sm')]: {
            right: theme.spacing(1),
        },
    },

    divide: {
        width: 1,
        height: 40,
        margin:"auto"
    },
    smButton: {
        paddingTop: 0,
        paddingBottom: 0,
        fontSize: "0.7rem",
        margin: 0,     
    },
    link: {
        fontSize: 14,
        color: theme.palette.grey[900]
    },
    linkBtn: {
        padding: 0,
        transition: "200ms ease",
        justifyContent: "left", 
        textAlign:"left",
        textTransform: 'capitalize',
        fontFamily: 'NHaasGroteskDSPro-55Rg',
        whiteSpace: "normal",
        maxWidth: "250px",
        [theme.breakpoints.down('xs')]: {
            width: "auto", 
        },
        '&:hover': {
            background: "transparent",
            textDecoration: "none",
        }
     
    },
    uploadColor: {
        color: theme.palette.primary.main,
        fontSize: 12,
        textDecoration: "underline",     
        marginTop: 4,
        '&:hover': {
            background: "transparent",
            textDecoration: "none",
        }
    },
    iconNext: {
        verticalAlign: "middle",
    },

	assignLineButton: {
		fontFamily: 'NHaasGroteskDSPro-55Rg',
		fontSize: '0.8rem',
		textTransform: 'none',
		padding: '4px 8px',
		boxShadow: 'none',
		minWidth: 0,
		justifyContent: 'flex-start',
	},
	lineAssignWrap: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'flex-start',
		gap: theme.spacing(0.5),
		maxWidth: 260,
	},
	lineAssignedChip: {
		height: 22,
		fontSize: 11,
	},
	dateStack: {
		whiteSpace: 'normal',
		minWidth: 120,
	},
	dateRow: {
		display: 'flex',
		alignItems: 'flex-start',
		gap: theme.spacing(0.75),
	},
	dateIconWrap: {
		flexShrink: 0,
		marginTop: 2,
		display: 'flex',
		alignItems: 'center',
	},
	dateExpiryBlock: {
		marginTop: theme.spacing(1),
	},
	dateExpiryBlockCompact: {
		marginTop: theme.spacing(0.5),
	},
	dateLabel: {
		display: 'block',
		color: 'rgba(0, 0, 0, 0.62)',
		fontSize: '0.75rem',
		lineHeight: 1.25,
		marginBottom: 2,
	},
	dateValue: {
		fontFamily: 'NHaasGroteskDSPro-65Md',
		fontSize: '0.875rem',
		lineHeight: 1.3,
	},
	dateValueSoon: {
		color: theme.palette.warning.dark,
	},
	dateValueExpired: {
		color: theme.palette.error.main,
	},
	serialsRatio: {
		display: 'block',
		textAlign: 'right',
		fontSize: '0.7rem',
		color: theme.palette.text.secondary,
		marginTop: 2,
		lineHeight: 1.2,
	},
	serialsEmptyHint: {
		display: 'block',
		textAlign: 'right',
		fontSize: '0.75rem',
		color: theme.palette.text.secondary,
		fontStyle: 'italic',
		marginTop: 4,
		lineHeight: 1.3,
	},
	serialsEmptyOnly: {
		textAlign: 'right',
		minWidth: 100,
	},
	typeSummaryBlock: {
		cursor: 'default',
		marginTop: 2,
	},
	dateStatusChip: {
		marginTop: theme.spacing(0.5),
		height: 22,
		fontSize: 11,
		fontWeight: 600,
	},
	dateStatusChipSoon: {
		borderColor: theme.palette.warning.dark,
		color: theme.palette.warning.dark,
		backgroundColor: theme.palette.common.white,
	},
	compactRow: {
		'& > td': {
			paddingTop: theme.spacing(1),
			paddingBottom: theme.spacing(1),
		},
	},
	typeCellStack: {
		maxWidth: 220,
	},
	typeMetaEllipsis: {
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		whiteSpace: 'nowrap',
	},
	failedEmpty: {
		color: theme.palette.text.disabled,
		cursor: 'default',
		fontSize: '1.1rem',
	},
	stickyMfr: {
		position: 'sticky',
		left: 0,
		zIndex: 3,
		minWidth: STICKY_MFR_WIDTH,
		maxWidth: 220,
		backgroundColor: theme.palette.common.white,
		boxShadow: '2px 0 6px -4px rgba(0,0,0,0.12)',
	},
	stickyMfrStripe: {
		backgroundColor: theme.palette.grey[50],
	},
	stickyModel: {
		position: 'sticky',
		left: STICKY_MFR_WIDTH,
		zIndex: 2,
		minWidth: 240,
		backgroundColor: theme.palette.common.white,
		boxShadow: '2px 0 6px -4px rgba(0,0,0,0.1)',
	},
	stickyModelStripe: {
		backgroundColor: theme.palette.grey[50],
	},
	stickyModelOnly: {
		position: 'sticky',
		left: 0,
		zIndex: 3,
		minWidth: 260,
		backgroundColor: theme.palette.common.white,
		boxShadow: '2px 0 6px -4px rgba(0,0,0,0.12)',
	},
	stickyModelOnlyStripe: {
		backgroundColor: theme.palette.grey[50],
	},
    wordBreak :{
        whiteSpace:"normal",
    },
    bottom: {
        margin:"5px 0",
    },
	htmlPopper: {},
    htmlTooltip: {
        backgroundColor: '#f5f5f9',
        color: 'rgba(0, 0, 0, 0.87)',
        maxWidth: 220,
        fontSize: theme.typography.pxToRem(12),
        border: '1px solid #dadde9',
        '& b': {
            fontWeight: theme.typography.fontWeightMedium,
        },
    },
};

const RefineTableCell = withStyles(theme => ({
  
       body: {
        padding: theme.spacing(2),
        borderBottomColor: theme.palette.common.borderColor,
        fontSize: 14,
		verticalAlign: 'top',
           whiteSpace: 'nowrap',
         
          
        [theme.breakpoints.down('sm')]: {
            display: "block",
            textAlign: "right",  
            minHeight: " 73px",
            lineHeight: "42px",
            borderBottom:"none",
            '&:before': {
                content: "attr(data-label)",
                float:"left",
                fontWeight:"bold",
                textTransform: " uppercase",
                lineHeight: "42px",
                marginRight: "16px",
            },
        },
    },
}))(TableCell);



const navText = `
Click to see more details
`;
const ResolveText = `
Resolve the failed serials under this model.
`;
const uploadText = `
Upload more serials under this model.
`;

function formatProductSource(ps) {
    if (!ps) return '';
    if (ps === 'ADMIN_MANUAL') return 'Manual';
    if (ps === 'CEC_SYNC') return 'CEC';
    return ps;
}

function formatModelNameType(t) {
    if (t == null || t === '') return '—';
    const u = String(t).toUpperCase();
    if (u === 'INTERNAL') return 'Internal';
    if (u === 'CEC') return 'CEC';
    return String(t);
}

function formatBatteryComponentTypeLabel(t) {
    if (t == null || t === '') return '';
    const u = String(t).toUpperCase();
    if (u === 'MODULAR' || u === 'MODULE') return 'Modular';
    if (u === 'MASTER') return 'Master';
    if (u === 'STANDALONE') return 'Standalone';
    if (u === 'INVERTER_CONTROLLER') return 'Inverter controller';
    return String(t);
}

function isInverter(productType) {
    return productType && String(productType).toUpperCase() === 'INVERTER';
}

class ProductRow extends React.Component {
    constructor(props) {
        super(props);
        this._id = _.uniqueId('model_row');
        this.state = { enrichOpen: false };
        this.handleProductLineAssignment = this.handleProductLineAssignment.bind(this);

    }

    handleClose = () => {
        this.setState({ open: false });
    };
 
    _getQueryVariables() {

        const page = this.state.pageNumber;
        const page_size = this.state.pageSize;
        const skip = (page - 1) * page_size;
        const filter = this.state.filter;
        const first = page_size;
        return { first, skip, filter }
    }
    handleProductLineAssignment() {        
        const {  model } = this.props;
        if (typeof this.props.shouldOpenDialog === 'function') {
            this.props.shouldOpenDialog('body', model);
        }
        return false;
    }
   
    render() {
        const {
			classes,
			model,
			adminView,
			isDistributor,
			index,
			showManufacturer,
			compactTable,
			hideSerialsDivider,
			showWarranty = true,
		} = this.props;
        const stripe = index != null && index % 2 === 1;
        const warranty = model.productWarranty;
		const modelDisplayName = model.displayModelName || model.model || '—';
		const batteryLabel = model.batteryComponentType
			? formatBatteryComponentTypeLabel(model.batteryComponentType)
			: '';
		const powerLine = formatProductPowerLine(model);
        const subheader = (
            <Fragment>
                {powerLine && (
                    <Typography
						component="span"
						variant="body2"
						color="textSecondary"
						display="block"
						style={{ lineHeight: 1.45, marginTop: 4 }}
					>
                        {powerLine}
                    </Typography>
                )}
                {model.nominalStorageKwh != null && model.nominalStorageKwh !== '' && (
                    <Typography
						component="span"
						variant="body2"
						color="textSecondary"
						display="block"
						style={{ lineHeight: 1.45, marginTop: 4 }}
					>
                        Nom. storage: {model.nominalStorageKwh} kWh
                    </Typography>
                )}
            </Fragment>
        );

		const typeDetailLines = isInverter(model.productType)
			? [model.inverterType ? `Equipment: ${model.inverterType}` : 'Equipment: —']
			: _.compact([
				`Component: ${batteryLabel || '—'}`,
				model.cecEquipmentCategory ? `Listing: ${model.cecEquipmentCategory}` : null,
			])
		const typeSummaryOneLine = typeDetailLines.join(' · ')
		const typeTooltipBody = (
			<div>
				{typeDetailLines.map((line, i) => (
					<div key={i}>{line}</div>
				))}
			</div>
		)
		const typeSummaryTooltip = (
			<Tooltip
				title={typeTooltipBody}
				placement="top"
				classes={{
					popper: classes.htmlPopper,
					tooltip: classes.htmlTooltip,
				}}
			>
				<div className={classes.typeSummaryBlock}>
					<Typography
						variant="body2"
						color="textSecondary"
						display="block"
						className={classes.typeMetaEllipsis}
					>
						{typeSummaryOneLine}
					</Typography>
				</div>
			</Tooltip>
		)
        
        const productLine = model.productLine
			? isDistributor
				? model.productLine.lineName
				: (
					<div className={classes.lineAssignWrap}>
						<Chip
							label="Assigned"
							size="small"
							variant="outlined"
							className={classes.lineAssignedChip}
						/>
						<Button
							size="small"
							color="primary"
							disableRipple
							className={classes.linkBtn}
							onClick={() => this.handleProductLineAssignment()}
						>
							{model.productLine.lineName}
						</Button>
					</div>
				)
			: isDistributor
				? 'No Product Line Assigned'
				: (
					<Tooltip
						title="Choose a product line for this model. Warranties are taken from the assigned line."
						placement="top"
					>
						<span>
							<Button
								variant="text"
								color="primary"
								size="small"
								className={classes.assignLineButton}
								startIcon={<LinkIcon style={{ fontSize: 16 }} />}
								onClick={() => this.handleProductLineAssignment()}
								aria-label={`Assign product line for ${modelDisplayName}`}
							>
								{compactTable ? 'Assign line' : 'Assign product line'}
							</Button>
						</span>
					</Tooltip>
				);
        const serialStats = model.serialStats != null ? model.serialStats : { "installed": 0, "failed": 0, "pending": 0, "totalRequests": 0 };
        const navigation_row = this.props.hideDetailNavigation ? <RefineTableCell></RefineTableCell> : (<RefineTableCell data-label="View more details" >
            <Tooltip placement="bottom-start"
                classes={{
                    popper: classes.htmlPopper,
                    tooltip: classes.htmlTooltip,
                    tooltipPlacementBottom: classes.bottom
                }}              
                title={navText}
                interactive>
                <IconButton component={Link} to={{ pathname: "/model/" + model.productId, state: { model: model } }} className={classes.margin}>
                    <NavigateNext className={classes.iconNext} />                  
                </IconButton>
            </Tooltip>
        </RefineTableCell>);
        const productLineContent = productLine;
        
        const { totalRequests, failed, installed, pending } = serialStats;
        const failedWidth = serialStats && totalRequests === 0 ? 0 : failed > 0 ? Math.max(Math.floor((failed / totalRequests) * 100),1) : 0;
        
        const availableWidth = serialStats && pending === 0 && serialStats.installed === 0 ? 0 : Math.floor((pending / (installed + pending)) * 100);
		const totalSerialPool = installed + pending;
		const serialsTooltip = `Available for verification (pending): ${pending}. Total pool (installed + pending): ${totalSerialPool}. The bar shows the share of the pool still available.`;
        const resolveLink = this.props.hideDetailNavigation ? null : (<Tooltip title={ResolveText} placement="bottom-start" classes={{
            popper: classes.htmlPopper,
            tooltip: classes.htmlTooltip,
            tooltipPlacementBottom: classes.bottom
        }} >

            <Button className={(classNames(classes.uploadColor, classes.linkBtn))}  component={Link} to={{ pathname: "/model/" + model.productId, state: { model: model } }}>
                Resolve
            </Button>

           </Tooltip>);

        const uploadlink = this.props.hideDetailNavigation ? null : (<Tooltip title={uploadText} placement="bottom-start" classes={{
            popper: classes.htmlPopper,
            tooltip: classes.htmlTooltip,
            tooltipPlacementBottom: classes.bottom
        }} >
            <Button color="primary" className={classNames(classes.linkBtn, classes.uploadColor)} component={Link} to={{ pathname: "/flash" }}>
                Upload more serials
            </Button>
        
        </Tooltip>);

        const faildSection = failedWidth > 0 ? (<Fragment>
			<div className={classes.failedBadgeRow}>
				<Chip
					size="small"
					label={failed}
					className={classes.failedBadgeChip}
					variant="outlined"
				/>
				<div className={classes.progress} style={{ flex: '1 1 120px', minWidth: 80 }}>
					<LinearProgress variant="determinate" value={failedWidth} classes={{
						determinate: classes.linearFailedPrimary,
						bar1Determinate: classes.linearFailedBarColorPrimary,
					}} />
					<span className={classes.spanFailed}>{failed}/{totalRequests}</span>
				</div>
			</div>
            {adminView ? null : ( resolveLink)}  </Fragment>) : (
			<Tooltip
				title="Failed verification requests vs total requests for this model. No failures is expected for healthy products."
				placement="top"
				classes={{
					popper: classes.htmlPopper,
					tooltip: classes.htmlTooltip,
				}}
			>
				<span className={classes.failedEmpty}>—</span>
			</Tooltip>
		);
           
        const enrichButton = this.props.role === Role_Admin ? (
            <Tooltip title="Enrich product" placement="bottom-start">
                <IconButton size="small" onClick={() => this.setState({ enrichOpen: true })} style={{ marginLeft: 4 }}>
                    <TuneIcon fontSize="small" />
                </IconButton>
            </Tooltip>
        ) : null;

		const modelTitleInner = this.props.hideDetailNavigation ? (
			modelDisplayName
		) : (
			<Link
				to={{ pathname: '/model/' + model.productId, state: { model: model } }}
				className={classes.modelTitleLink}
			>
				{modelDisplayName}
			</Link>
		);

		const apprDisplay = formatProductDisplayDate(model.approvedDate);
		const expDisplay = formatProductDisplayDate(model.expiryDate);
		const expiryUrgency = getExpiryUrgency(model.expiryDate);
		const expiryValueClass =
			expiryUrgency === 'expired'
				? classes.dateValueExpired
				: expiryUrgency === 'soon'
					? classes.dateValueSoon
					: '';
		const expiryEventColor =
			expiryUrgency === 'expired'
				? 'error'
				: expiryUrgency === 'soon'
					? 'secondary'
					: 'action';
		const datesTooltip = (
			<Fragment>
				<div>{buildProductDateTooltip('approved', model.approvedDate, apprDisplay)}</div>
				<div>{buildProductDateTooltip('expiry', model.expiryDate, expDisplay)}</div>
			</Fragment>
		);

        return (
            <Fragment>
            <TableRow className={classNames(classes.row, compactTable && classes.compactRow)}>
                {showManufacturer && (
                    <RefineTableCell
						data-label="Manufacturer"
						className={classNames(classes.stickyMfr, stripe && classes.stickyMfrStripe)}
					>
                        <Typography variant="body2">{model.manufacturerName || '—'}</Typography>
                    </RefineTableCell>
                )}
                <RefineTableCell
					data-label="Models"
					className={classNames(
						showManufacturer ? classes.stickyModel : classes.stickyModelOnly,
						stripe && (showManufacturer ? classes.stickyModelStripe : classes.stickyModelOnlyStripe),
					)}
				>
                    <CardHeader
                        avatar={
                            isInverter(model.productType)
                                ? <Avatar className={classes.avatarInverter}><FlashOnIcon /></Avatar>
                                : <Avatar className={classes.avatarBattery}><BatteryChargingFullIcon /></Avatar>
                        }
                        title={
                            <span className={classes.modelTitleRow}>
                                {modelTitleInner}
                                {enrichButton}
                            </span>
                        }
                        subheader={subheader}
                        classes={{
							root: classNames(classes.space, classes.modelCardHeader),
							title: classes.headerTitle,
							subheader: classes.headerTitle,
						}}
                    />
                </RefineTableCell>
                <RefineTableCell data-label="Type" style={{ whiteSpace: 'normal', verticalAlign: 'top' }}>
					<div className={classes.typeCellStack}>
						<Typography variant="body2" className={classes.headerTitle}>
							{formatModelNameType(model.modelNameType)}
						</Typography>
						{typeSummaryTooltip}
						{model.productSource === 'ADMIN_MANUAL' ? (
							<Typography
								variant="caption"
								color="textSecondary"
								display="block"
								style={{ marginTop: 6 }}
							>
								Source: {formatProductSource(model.productSource)}
							</Typography>
						) : null}
					</div>
                </RefineTableCell>
                <RefineTableCell data-label="Product line">
                    {productLineContent}
                </RefineTableCell>
                <RefineTableCell data-label="Approval & expiry">
					<Tooltip
						title={datesTooltip}
						placement="top-start"
						classes={{
							popper: classes.htmlPopper,
							tooltip: classes.htmlTooltip,
						}}
					>
						<div className={classes.dateStack}>
							<div className={classes.dateRow}>
								<span className={classes.dateIconWrap} aria-hidden>
									<CheckCircleOutline fontSize="small" color="action" />
								</span>
								<div>
									<Typography variant="caption" className={classes.dateLabel}>
										Approved
									</Typography>
									<Typography variant="body2" component="div" className={classes.dateValue}>
										{apprDisplay}
									</Typography>
								</div>
							</div>
							<div
								className={classNames(
									classes.dateExpiryBlock,
									compactTable && classes.dateExpiryBlockCompact,
								)}
							>
								<div className={classes.dateRow}>
									<span className={classes.dateIconWrap} aria-hidden>
										<Event fontSize="small" color={expiryEventColor} />
									</span>
									<div>
										<Typography variant="caption" className={classes.dateLabel}>
											Expires
										</Typography>
										<Typography
											variant="body2"
											component="div"
											className={classNames(classes.dateValue, expiryValueClass)}
										>
											{expDisplay}
										</Typography>
										{expiryUrgency === 'expired' ? (
											<Chip
												size="small"
												label="Expired"
												variant="outlined"
												color="secondary"
												className={classes.dateStatusChip}
											/>
										) : null}
										{expiryUrgency === 'soon' ? (
											<Chip
												size="small"
												label="Expiring soon"
												variant="outlined"
												className={classNames(
													classes.dateStatusChip,
													classes.dateStatusChipSoon,
												)}
											/>
										) : null}
									</div>
								</div>
							</div>
						</div>
					</Tooltip>
				</RefineTableCell>
                {showWarranty ? (
					<Fragment>
						<RefineTableCell data-label="Component Warranty">
							<WarrantyCell
								isDistributor={isDistributor}
								compactWarranty={!!compactTable}
								onOpenProductLineDialog={this.handleProductLineAssignment}
								warrantyKind="component"
								productSummaryForA11y={modelDisplayName}
								iswarrantyExists={warranty != null && (warranty.componentInYears != null || warranty.componentWarrantyLink != null)}
								warrantyInYears={warranty != null ? warranty.componentInYears : 0}
								warrantyLinks={warranty != null ? warranty.componentWarrantyLink : null}
							/>
						</RefineTableCell>
						<RefineTableCell data-label="Performance Warranty">
							<WarrantyCell
								isDistributor={isDistributor}
								compactWarranty={!!compactTable}
								onOpenProductLineDialog={this.handleProductLineAssignment}
								warrantyKind="performance"
								productSummaryForA11y={modelDisplayName}
								iswarrantyExists={warranty != null && (warranty.performanceInYears != null || warranty.performanceWarrantyLink != null)}
								warrantyInYears={warranty != null ? warranty.performanceInYears : 0}
								warrantyLinks={warranty != null ? warranty.performanceWarrantyLink : null}
							/>
						</RefineTableCell>
					</Fragment>
				) : null}
                <RefineTableCell align="right" data-label="Available Serials">
					<Tooltip
						title={serialsTooltip}
						placement="top"
						classes={{
							popper: classes.htmlPopper,
							tooltip: classes.htmlTooltip,
						}}
					>
						<div>
							{totalSerialPool === 0 ? (
								<div className={classes.serialsEmptyOnly}>
									<Typography variant="body2" color="textSecondary" component="div">
										0 / 0
									</Typography>
									<Typography variant="caption" className={classes.serialsEmptyHint} component="div">
										No serials in pool
									</Typography>
								</div>
							) : (
								<Fragment>
									<div className={classes.progress}>
										<LinearProgress
											variant="determinate"
											value={availableWidth}
											classes={{
												determinate: classes.linearColorPrimary,
												bar1Determinate: classes.linearBarColorPrimary,
											}}
										/>
										<span className={classes.span}>{pending}</span>
									</div>
									<Typography variant="caption" className={classes.serialsRatio} component="div">
										{pending} / {totalSerialPool}
									</Typography>
								</Fragment>
							)}
						</div>
					</Tooltip>
                    {adminView ? null : ( uploadlink )}             
                </RefineTableCell>
                {!hideSerialsDivider && (
					<Hidden xsDown>
						<RefineTableCell align="center"><Divider className={classes.divide} /></RefineTableCell>
					</Hidden>
				)}
                <RefineTableCell data-label="Failed Requests">
                    {faildSection}
                </RefineTableCell>
                {adminView ? null : ( navigation_row )}   
            </TableRow>
            {this.state.enrichOpen && (
                <ProductEnrichPanel
                    open={this.state.enrichOpen}
                    onClose={() => this.setState({ enrichOpen: false })}
                    product={model}
                />
            )}
        </Fragment>

        );




    }
}

ProductRow.defaultProps = {
	showWarranty: true,
};

export default withStyles(styles)(ProductRow);
